import { useTranslate } from 'ra-core'
import { useRecordContext } from 'react-admin'

import StaticText from './StaticText'
import { ORGANISATION_EMAIL_NOTIFICATIONS } from '../config/organisations'
import { useShowStyles } from '../resources/common/show'

const OrganisationEmailNotificationsField = () => {
  const record = useRecordContext()
  const showClasses = useShowStyles()
  const translate = useTranslate()

  if (ORGANISATION_EMAIL_NOTIFICATIONS.every((n) => record[n.code] === false)) {
    return <StaticText>resources.organisations.emailNotifications.empty</StaticText>
  }

  return (
    <ul style={showClasses.unorderedList}>
      {ORGANISATION_EMAIL_NOTIFICATIONS.map(
        (n) =>
          record[n.code] && (
            <li key={n.code} style={showClasses.unorderedListItem}>
              <p>{translate(n.label)}</p>
            </li>
          ),
      )}
    </ul>
  )
}

OrganisationEmailNotificationsField.defaultProps = {
  label: 'resources.organisations.fields.has_email_notifications',
}

export default OrganisationEmailNotificationsField
